import React from 'react';
import { IconButton, Pagination } from '@axiom/ui';

import type { EngagementsHistorySearchResponse } from '../../schema/engagements-history-search-response-schema';

export type EngagementsHistoryViewPaginationProps = {
  meta?: EngagementsHistorySearchResponse['meta'];
  name: string;
};

export const EngagementsHistoryViewPagination = ({
  meta,
  name,
}: EngagementsHistoryViewPaginationProps) => {
  const pageCount = meta?.pageCount ?? 0;
  const currentPage = meta?.currentPage ?? 0;

  const getPaginationLink = (incremental: number) => {
    const queryParams = window.location.search || '';
    const incrementPage = currentPage + incremental;
    const pageNumberClamped = Math.min(Math.max(incrementPage, 1), pageCount);
    const pageIndicator =
      pageNumberClamped > 1 ? `./page/${pageNumberClamped}` : './';
    return `${pageIndicator}${queryParams}`;
  };

  return (
    <Pagination
      name={name}
      currentPage={currentPage}
      totalPages={pageCount}
      nextButton={
        <IconButton
          icon="arrow-right"
          name="pagination-next-button"
          variation="minimal"
          pattern="secondary"
          to={getPaginationLink(1)}
        />
      }
      prevButton={
        <IconButton
          icon="arrow-left"
          name="pagination-prev-button"
          pattern="secondary"
          variation="minimal"
          to={getPaginationLink(-1)}
        />
      }
    />
  );
};
